import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { Camera } from "@ionic-native/camera";
import { OneSignal } from "@ionic-native/onesignal";
import { ChartsModule } from "ng2-charts";
import { DocumentViewer } from "@ionic-native/document-viewer/ngx";
import { DatePicker } from "@ionic-native/date-picker";
import { IonicImageLoader } from "ionic-image-loader";
import { CalendarModule } from "ion2-calendar";
import { FileChooser } from "@ionic-native/file-chooser";
import { FilePath } from "@ionic-native/file-path";
import { PhotoViewer } from "@ionic-native/photo-viewer";
import { Geolocation } from "@ionic-native/geolocation";
import { AndroidPermissions } from "@ionic-native/android-permissions";
import { Calendar } from "@ionic-native/calendar";
import { ScreenOrientation } from "@ionic-native/screen-orientation";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { NgxQRCodeModule } from "ngx-qrcode2";
import { LottieAnimationViewModule } from "ng-lottie";
import { Deeplinks } from "@ionic-native/deeplinks";
import { Device } from "@ionic-native/device/ngx";
import { IonicImageViewerModule } from "ionic-img-viewer";
import { AppVersion } from "@ionic-native/app-version";
import { Market } from "@ionic-native/market";
import { BackgroundMode } from "@ionic-native/background-mode";
import { Clipboard } from "@ionic-native/clipboard";
import { CurrencyPipe } from "@angular/common";

// import { ComponentsModule } from "../components/components.module";
import { ForbidenloginComponent } from "../components/forbidenlogin/forbidenlogin";
import { cmpFilterKaryawan } from "../components/presensi";
import { ResourceTreeComponent } from "../components/resource-tree/resource-tree";
import { TreeComponent } from "../components/tree/tree";
import { tomyradiantComponent } from "@src/components/Button";
import {
  drawerVerticalCmp,
  DailyActivity,
  DetailNotesMyTeam,
  FilterProjectApps,
} from "@src/components/Content";

import { MyApp } from "./app.component";

import { CKEditorModule } from "ng2-ckeditor";
import { FormsModule } from "@angular/forms";
import { IonicSelectableModule } from "ionic-selectable";
import { File } from "@ionic-native/file";

//plugin dari hanafiq
// import { SuperTabsModule } from '@ionic-super-tabs/angular';

import { ChangePasswordPage } from "@pages/changePassword/page";

import {
  DashboardPage,
  ListProjectPage,
  NotesPage,
  ProjectDetailPage,
  SchedulePage,
  TaskPage,
  FormTaskPage,
  FormSchedulePage,
  DetailSchedulePage,
  DetailTaskPage,
  FormNotePage,
  ProfilePage,
  ActivityPage,
  FormProjectPage,
  LoginPage,
  DetailImagePage,
  AboutPage,
  ListNotificationPage,
  ListSubscribersPage,
  SelectPage,
  DetailUsagePage,
  DetailBudgetPage,
  InvoicePage,
  DetailInvPage,
  ListAR,
  FormInvPage,
} from "@pages/project_mobile";

// page advance
import {
  TabsAdvance,
  LoginPage as LoginAdvance,
  HomePage as HomeAdvance,
  DetailAdvPage,
  AdvEmployeePage,
  ListEmployeePage,
  OrganizationPage,
  UserAdvPage,
  AboutAdvance,
  ContactAdvance,
} from "@pages/advance_mobile";

//page dashboard
import {
  HomePage,
  TabsPage,
  PortalPage,
  LoginPage as LoginMyRadiant,
  ProfilPage,
  DetailNewsPage,
  EditPegawai,
  DetailPresensi,
  Aproval as AprovalPage,
  AprovalDetail,
  NewsPage,
  NotifikasiPage,
} from "@pages/dashboard";

//page presensi
import {
  AppPresensi,
  Attendance,
  Leave,
  Permit,
  Overtime,
  AddOvertime,
  AddPermit,
  PlanOvertime,
  PlanOvertimeBawahan,
} from "@pages/presensi";

// page attendance
import {
  AddAttendance,
  AppAttendance,
  MyAttendance,
  Employee as EmployeeAttedance,
  DetailAttendance,
} from "../pages/attendance";

import {
  AddActivity,
  AppActivity,
  MyActivity,
  Employee,
  DetailEmployeeActivity,
  DetailActivity,
  IdleStaff,
  DetailIdle,
  Tracking,
  DetailTrackingActivity,
  MarkerPage,
  UbahActivity,
  HistoryTracking,
  TrackingWeb,
} from "@pages/activity";

import {
  HomePage as HomeAsset,
  ItemPage,
  LocationPage,
  ConditionPage,
  ClassificationPage,
  AssetPage,
  FormItemPage,
  DetailItemPage,
  ScanCodePage,
  PrintCodePage,
  FormClassificationPage,
  FormLocationPage,
  TrackingPage,
  PicPage,
  ReportPage,
  ProfilePage as ProfilePageAsset,
  ReviewPage,
  DepartmentPage,
  ProjectPage,
  DetailImagePage as DetailImagePageAsset,
  FinishOpnamePage,
  LoginPage as LoginPageAsset,
  AboutPage as AboutPageAsset,
  FormReviewPage,
  DetailReviewPage,
  ActivityPage as ActivityPageAsset,
  DetailItemERPPage,
  AssetReviewsPage,
  SelectPage as SelectPageAsset,
  AssignmentPage,
  AssignmentResPage,
  FormAssignmentPage,
  LsAssignmentPage,
  AssetDocumentsPage,
  FormDocumentsPage,
} from "@pages/asset";

import {
  DashboardPage as DashboardPageMarketing,
  ListProjectPage as ListProjectPageMarketing,
  ProjectDetailPage as ProjectDetailPageMarketing,
  SchedulePage as SchedulePageMarketing,
  TaskPage as TaskPageMarketing,
  NotesPage as NotesPageMarketing,
  FormTaskPage as FormTaskPageMarketing,
  FormSchedulePage as FormSchedulePageMarketing,
  LoginPage as LoginPageMarketing,
  DetailSchedulePage as DetailSchedulePageMarketing,
  DetailTaskPage as DetailTaskPageMarketing,
  FormNotePage as FormNotePageMarketing,
  FormTenderPage as FormTenderPageMarketing,
  ProfilePage as ProfilePageMarketing,
  ActivityPage as ActivityPageMarketing,
  DetailImagePage as DetailImagePageMarketing,
  AboutPage as AboutPageMarketing,
  ListTenderSubscribersPage as ListTenderSubscribersPageMarketing,
  SelectPage as SelectPageMarketing,
  ListNotificationPage as ListNotificationPageMarketing,
  PostTenderPage as PostTenderPageMarketing,
  FormPostTenderPage as FormPostTenderPageMarketing,
} from "@pages/marketing";

import {
  ListFormPage,
  FormPage,
  ListFormResponsePage,
  DetailResponsePage,
} from "@pages/survey";

import {
  ListFormPageDynamic,
  FormPageDynamic,
  ListFormResponsePageDynamic,
  DetailResponsePageDynamic,
} from "@pages/dynamic_form";

import {
  ListFormOpnamePage,
  ListItemFaskerPage,
  DetailItemFaskerPage,
  FormItemFaskerPage,
} from "@pages/opname";

// PROVIDER
import {
  Api,
  Project,
  Master,
  Schedule,
  Task,
  Notes,
  User,
  Dokumen,
  Subscriber,
  ApiMyRadiant,
  UserMyRadiant,
  LoginMyRadiant as providerLoginMyRadiant,
  RepositoryMyRadiant,
  HelperMyRadiant,
  UtilityMyRadiant,
  PermitProvider,
  OvertimeProvider,
  Me,
  ResourceTreeProvider,
  MasterAsset,
  TrackingAsset,
  Reviews,
  DokumenAsset,
  assetDocuments,
  UserAsset,
  Assignment,
  Item,
  ApiAsset,
  ApiMarketing,
  TenderMarketing,
  MasterMarketing,
  ScheduleMarketing,
  TaskMarketing,
  NotesMarketing,
  UserMarketing,
  DokumenMarketing,
  SubscriberMarketing,
  AprovalProvider,
  News,
  NotificationProvider,
  ApiApproval,
  WorkflowApproval,
  SettingsApproval,
  UserApproval,
  GlobalVarApproval,
  PresensiProvider,
  FaskerProvider,
  NotesMyTeamProvider,
  Form,
  EmployeeAttendanceProvider,
  TrackingFasker,
  Invoice,
} from "@providers/index";

import { IonBottomDrawerModule } from "ion-bottom-drawer";

import {
  Api as ApiAdvance,
  User as UserAdvance,
  Master as MasterAdvance,
  Advance,
  Dashboard,
} from "../providers/advance_providers";

import { Base64 } from "@ionic-native/base64";
import { FileTransfer, FileTransferObject } from "@ionic-native/file-transfer";
import { PreviewAnyFile } from "@ionic-native/preview-any-file/ngx";
import { FileOpener } from "@ionic-native/file-opener";
// import { NgCalendarModule  } from 'ionic2-calendar';
import { AboutApp } from "@pages/about/page";
import { cmpMyOrganization } from "../components/myOrganization/cmp";
import { UserPresensi } from "../providers/presensi";
import { FeedbackProvider } from "../providers/myradiant/feedback/provider";
import { TranslateModule } from "@ngx-translate/core";

import {
  LoginPageAproval,
  ChronologyPageAproval,
  DashboardPageAproval,
  ItemCreatePageAproval,
  ItemDetailPageAproval,
  ListMasterPageAproval,
  ListTaskPageApproval,
  MonitoringPageAproval,
  ProfilePageAproval,
  TabsPageAproval,
} from "@pages/aproval_erp/";
import { cmpDepartmentList } from "@src/components/departmentList/cmp";
import { IonicStorageModule } from "@ionic/storage";
import { StaffIdle, Tracker as GPSTrackerActivity } from "@providers/activity";
import { FAQPage } from "@pages/faq/page";
import { ModalsComponent } from "@src/components/modals/cmp";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { GoogleMaps } from "@ionic-native/google-maps";
import { Diagnostic } from "@ionic-native/diagnostic";
// import {
//   BackgroundGeolocation
// } from '@ionic-native/background-geolocation';
@NgModule({
  declarations: [
    MyApp,
    AboutApp,
    FAQPage,
    ChangePasswordPage,
    ForbidenloginComponent,
    ResourceTreeComponent,
    TreeComponent,
    tomyradiantComponent,
    drawerVerticalCmp,
    DailyActivity,
    DetailNotesMyTeam,
    FilterProjectApps,
    ModalsComponent,
    cmpFilterKaryawan,
    cmpDepartmentList,
    cmpMyOrganization,

    ListProjectPage,
    ProjectDetailPage,
    SchedulePage,
    TaskPage,
    NotesPage,
    DetailSchedulePage,
    DetailTaskPage,
    FormTaskPage,
    FormSchedulePage,
    LoginPage,
    DashboardPage,
    ActivityPage,
    FormNotePage,
    ProfilePage,
    FormProjectPage,
    DetailImagePage,
    AboutPage,
    ListNotificationPage,
    ListSubscribersPage,
    SelectPage,
    DetailUsagePage,
    DetailBudgetPage,
    InvoicePage,
    DetailInvPage,
    FormInvPage,
    ListAR,

    HomePage,
    TabsPage,
    LoginMyRadiant,
    PortalPage,

    LoginAdvance,
    HomeAdvance,
    DetailAdvPage,
    ListEmployeePage,
    AdvEmployeePage,
    OrganizationPage,
    UserAdvPage,
    ProfilPage,

    DetailNewsPage,
    DetailPresensi,
    AprovalPage,
    AprovalDetail,
    EditPegawai,
    TabsAdvance,
    AboutAdvance,
    ContactAdvance,
    NewsPage,
    LoginPageAproval,
    // ChronologyPageAproval,DashboardPageAproval,ItemCreatePageAproval,
    // ItemDetailPageAproval,
    ListMasterPageAproval,
    ListTaskPageApproval,
    MonitoringPageAproval,
    ProfilePageAproval,
    DetailEmployeeActivity,
    DetailActivity,
    MarkerPage,
    IdleStaff,
    DetailIdle,
    Tracking,
    DetailTrackingActivity,
    TrackingWeb,
    // TabsPageAproval,

    //modul presensi
    AppPresensi,
    Attendance,
    Leave,
    Permit,
    Overtime,
    AddOvertime,
    AddPermit,
    PlanOvertime,
    PlanOvertimeBawahan,
    NotifikasiPage,

    // module attendance
    AddAttendance,
    AppAttendance,
    MyAttendance,
    EmployeeAttedance,
    DetailAttendance,

    AddActivity,
    AppActivity,
    MyActivity,
    Employee,

    //modul asset
    HomeAsset,
    ItemPage,
    LocationPage,
    ConditionPage,
    ClassificationPage,
    AssetPage,
    FormItemPage,
    DetailItemPage,
    ScanCodePage,
    PrintCodePage,
    FormClassificationPage,
    FormLocationPage,
    TrackingPage,
    PicPage,
    ReportPage,
    ProfilePageAsset,
    ReviewPage,
    DepartmentPage,
    ProjectPage,
    DetailImagePageAsset,
    FinishOpnamePage,
    LoginPageAsset,
    AboutPageAsset,
    FormReviewPage,
    DetailReviewPage,
    ActivityPageAsset,
    DetailItemERPPage,
    AssetReviewsPage,
    SelectPageAsset,
    AssignmentPage,
    AssignmentResPage,
    FormAssignmentPage,
    LsAssignmentPage,
    AssetDocumentsPage,
    FormDocumentsPage,

    //modul marketing
    DashboardPageMarketing,
    ListProjectPageMarketing,
    ProjectDetailPageMarketing,
    SchedulePageMarketing,
    TaskPageMarketing,
    NotesPageMarketing,
    FormTaskPageMarketing,
    FormSchedulePageMarketing,
    LoginPageMarketing,
    DetailSchedulePageMarketing,
    DetailTaskPageMarketing,
    FormNotePageMarketing,
    FormTenderPageMarketing,
    ProfilePageMarketing,
    ActivityPageMarketing,
    DetailImagePageMarketing,
    AboutPageMarketing,
    UbahActivity,
    HistoryTracking,

    ListTenderSubscribersPageMarketing,
    SelectPageMarketing,
    ListNotificationPageMarketing,
    PostTenderPageMarketing,
    FormPostTenderPageMarketing,

    //modul survey
    ListFormPage,
    ListFormResponsePage,
    FormPage,
    DetailResponsePage,

    //modul dynamic form
    ListFormPageDynamic,
    ListFormResponsePageDynamic,
    FormPageDynamic,
    DetailResponsePageDynamic,

    //modul asset opname
    ListFormOpnamePage,
    ListItemFaskerPage,
    DetailItemFaskerPage,
    FormItemFaskerPage,
  ],
  imports: [
    BrowserModule,
    LottieAnimationViewModule.forRoot(),
    TranslateModule.forRoot(),
    IonicStorageModule.forRoot(),
    ChartsModule,
    NgxQRCodeModule,
    CalendarModule,
    // NgCalendarModule,
    // ComponentsModule,
    IonicSelectableModule,
    CKEditorModule,
    FormsModule,
    IonBottomDrawerModule,
    HttpClientModule,
    IonicImageViewerModule,
    IonicImageLoader.forRoot(),
    IonicModule.forRoot(MyApp, {
      mode: "ios",
      modalEnter: "modal-slide-in",
      modalLeave: "modal-slide-out",
      backButtonText: "",
      pageTransition: "ios-transition",
    }),
    // SuperTabsModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutApp,
    FAQPage,
    ChangePasswordPage,
    //untuk project
    ModalsComponent,
    ListProjectPage,
    ForbidenloginComponent,
    ResourceTreeComponent,
    TreeComponent,
    tomyradiantComponent,
    // drawerVerticalCmp,
    DailyActivity,
    DetailNotesMyTeam,
    FilterProjectApps,
    cmpFilterKaryawan,
    cmpDepartmentList,
    cmpMyOrganization,

    ProjectDetailPage,
    SchedulePage,
    TaskPage,
    NotesPage,
    DetailSchedulePage,
    DetailTaskPage,
    FormTaskPage,
    FormSchedulePage,
    LoginPage,
    DashboardPage,
    ActivityPage,
    FormNotePage,
    ProfilePage,
    FormProjectPage,
    DetailImagePage,
    AboutPage,
    ListNotificationPage,
    ListSubscribersPage,
    SelectPage,
    DetailUsagePage,
    DetailBudgetPage,
    InvoicePage,
    DetailInvPage,
    FormInvPage,
    ListAR,

    DetailPresensi,
    AprovalPage,
    AprovalDetail,
    LoginPageAproval,
    DetailEmployeeActivity,
    DetailActivity,
    MarkerPage,
    IdleStaff,
    DetailIdle,
    Tracking,
    DetailTrackingActivity,
    TrackingWeb,
    // ChronologyPageAproval,DashboardPageAproval,ItemCreatePageAproval,
    // ItemDetailPageAproval,
    ListMasterPageAproval,
    ListTaskPageApproval,
    MonitoringPageAproval,
    ProfilePageAproval,
    // TabsPageAproval,

    //untuk my radiant / portal
    HomePage,
    TabsPage,
    PortalPage,
    LoginMyRadiant,
    ProfilPage,
    DetailNewsPage,
    NewsPage,
    EditPegawai,
    NotifikasiPage,
    //untuk advance
    LoginAdvance,
    HomeAdvance,
    DetailAdvPage,
    ListEmployeePage,
    AdvEmployeePage,
    OrganizationPage,
    UserAdvPage,
    TabsAdvance,
    AboutAdvance,
    ContactAdvance,

    //modul presensi
    AppPresensi,
    Attendance,
    Leave,
    Permit,
    Overtime,
    AddOvertime,
    AddPermit,
    PlanOvertime,
    PlanOvertimeBawahan,
    //modul attendance
    AddAttendance,
    AppAttendance,
    MyAttendance,
    EmployeeAttedance,
    DetailAttendance,

    AddActivity,
    AppActivity,
    MyActivity,
    Employee,

    //modul assets
    HomeAsset,
    ItemPage,
    LocationPage,
    ConditionPage,
    ClassificationPage,
    AssetPage,
    FormItemPage,
    DetailItemPage,
    ScanCodePage,
    PrintCodePage,
    FormClassificationPage,
    FormLocationPage,
    TrackingPage,
    PicPage,
    ReportPage,
    ProfilePageAsset,
    ReviewPage,
    DepartmentPage,
    ProjectPage,
    DetailImagePageAsset,
    FinishOpnamePage,
    LoginPageAsset,
    AboutPageAsset,
    FormReviewPage,
    DetailReviewPage,
    ActivityPageAsset,
    DetailItemERPPage,
    AssetReviewsPage,
    SelectPageAsset,
    AssignmentPage,
    AssignmentResPage,
    FormAssignmentPage,
    LsAssignmentPage,
    AssetDocumentsPage,
    FormDocumentsPage,

    //modul marketing
    DashboardPageMarketing,
    ListProjectPageMarketing,
    ProjectDetailPageMarketing,
    SchedulePageMarketing,
    TaskPageMarketing,
    NotesPageMarketing,
    FormTaskPageMarketing,
    FormSchedulePageMarketing,
    LoginPageMarketing,
    DetailSchedulePageMarketing,
    DetailTaskPageMarketing,
    FormNotePageMarketing,
    FormTenderPageMarketing,
    ProfilePageMarketing,
    ActivityPageMarketing,
    DetailImagePageMarketing,
    AboutPageMarketing,
    UbahActivity,
    HistoryTracking,

    ListTenderSubscribersPageMarketing,
    SelectPageMarketing,
    ListNotificationPageMarketing,
    PostTenderPageMarketing,
    FormPostTenderPageMarketing,

    //modul survey
    ListFormPage,
    ListFormResponsePage,
    FormPage,
    DetailResponsePage,

    //modul dynamic form
    ListFormPageDynamic,
    ListFormResponsePageDynamic,
    FormPageDynamic,
    DetailResponsePageDynamic,

    //modul asset opname
    ListFormOpnamePage,
    ListItemFaskerPage,
    DetailItemFaskerPage,
    FormItemFaskerPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Market,
    Clipboard,
    FeedbackProvider,
    BackgroundMode,
    StaffIdle,
    GPSTrackerActivity,
    FaskerProvider,
    NotesMyTeamProvider,
    Camera,
    OneSignal,
    DocumentViewer,
    InAppBrowser,
    Diagnostic,
    DatePicker,
    BarcodeScanner,
    FileChooser,
    Base64,
    FilePath,
    File,
    FileTransfer,
    PreviewAnyFile,
    FileOpener,
    FileTransferObject,
    PhotoViewer,
    FileTransfer,
    Geolocation,
    AndroidPermissions,
    Calendar,
    ScreenOrientation,
    ResourceTreeProvider,
    Deeplinks,
    AppVersion,
    PresensiProvider,
    GoogleMaps,
    Device,
    ApiApproval,
    WorkflowApproval,
    SettingsApproval,
    UserApproval,
    GlobalVarApproval,
    CurrencyPipe,
    //untuk project
    Api,
    Project,
    Master,
    Schedule,
    Task,
    Notes,
    User,
    Dokumen,
    Subscriber,
    Invoice,
    AprovalProvider,
    News,
    // untuk advance
    ApiAdvance,
    UserPresensi,
    UserAdvance,
    MasterAdvance,
    Advance,
    Dashboard,
    // BackgroundGeolocation,
    Me,
    //selesai advance

    // attendance
    EmployeeAttendanceProvider,

    // untuk my radiant / dashboard / portal
    ApiMyRadiant,
    UserMyRadiant,
    providerLoginMyRadiant,
    RepositoryMyRadiant,
    HelperMyRadiant,
    UtilityMyRadiant,
    PermitProvider,
    OvertimeProvider,
    NotificationProvider,

    //untuk assets
    MasterAsset,
    TrackingAsset,
    Reviews,
    DokumenAsset,
    assetDocuments,
    UserAsset,
    Assignment,
    Item,
    ApiAsset,
    TrackingFasker,

    //untuk marketing
    ApiMarketing,
    TenderMarketing,
    MasterMarketing,
    ScheduleMarketing,
    TaskMarketing,
    NotesMarketing,
    UserMarketing,
    DokumenMarketing,
    SubscriberMarketing,

    //untuk survey
    Form,

    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler,
    },
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts